
import { Options, Vue } from "vue-class-component"
// import { State, Action, Getter } from "vuex-class";

@Options({})
export default class SoundCloud extends Vue {
}
